var registeredCallback = null;
var insertSxSV2IntoDomHelper = {
    register: function (callback) {
        registeredCallback = callback;
    },
    available: function () { return !!registeredCallback; },
    run: function () {
        if (registeredCallback) {
            registeredCallback();
        }
    },
};
export default insertSxSV2IntoDomHelper;
//# sourceMappingURL=insertSxSV2IntoDomHelper.js.map